export default {
    "smartElectricity.smarElectricity.218347-0": "结算列表",
    "smartElectricity.smarElectricity.218347-1": "设置费率",
    "smartElectricity.smarElectricity.218347-2": "用户授权",
    "smartElectricity.smarElectricity.218347-3": "用户管理",
    "smartElectricity.smarElectricity.218347-4": "部门管理",
    "smartElectricity.smarElectricity.218347-5": "公司管理",
    "smartElectricity.smarElectricity.218347-6": "集团管理",
    "smartElectricity.smarElectricity.218347-7": "商户费用",
    "smartElectricity.smarElectricity.218347-8": "一键导入",
    "smartElectricity.smarElectricity.218347-9": "警报",
    "smartElectricity.smarElectricity.218347-10": "返回",
    "smartElectricity.smarElectricity.218347-11": "用户数",
    "smartElectricity.smarElectricity.218347-12": "户",
    "smartElectricity.smarElectricity.218347-13": "告警设备",
    "smartElectricity.smarElectricity.218347-14": "台",
    "smartElectricity.smarElectricity.218347-15": "在线设备",
    "smartElectricity.smarElectricity.218347-16": "离线设备",
    "smartElectricity.smarElectricity.218347-17": "查看报表",
    "smartElectricity.smarElectricity.218347-18": "设备告警数",
    "smartElectricity.smarElectricity.218347-19": "次",
    "smartElectricity.smarElectricity.218347-20": "已处理数",
    "smartElectricity.smarElectricity.218347-21": "当日待处理数",
    "smartElectricity.smarElectricity.218347-22": "城市列表",
    "smartElectricity.smarElectricity.218347-23": "刷新",
    "smartElectricity.smarElectricity.218347-24": "搜索",
    "smartElectricity.smarElectricity.218347-25": "请输入名称搜索",
    "smartElectricity.smarElectricity.218347-26": "暂无数据",
    "smartElectricity.smarElectricity.218347-27": "暂无区域",
    "smartElectricity.smarElectricity.218347-28": "暂无城市",
    "smartElectricity.smarElectricity.218347-29": "报表",
    "smartElectricity.smarElectricity.218347-30": "泰邦",
    "smartElectricity.smarElectricity.218347-31": "区域：浙江省-台州市-玉环县",
    "smartElectricity.smarElectricity.218347-32": "请输入名称或者设备码搜索",
    "smartElectricity.smarElectricity.218347-33": "在线",
    "smartElectricity.smarElectricity.218347-34": "正常",
    "smartElectricity.smarElectricity.218347-35": "楼上车间",
    "smartElectricity.smarElectricity.218347-36": "设备码：10001010",
    "smartElectricity.smarElectricity.218347-37": "用户设备列表",
    "smartElectricity.smarElectricity.218347-38": "您确认删除此用户吗？",
    "smartElectricity.smarElectricity.218347-39": "删除用户",
    "smartElectricity.smarElectricity.218347-40": "添加设备",
    "smartElectricity.smarElectricity.218347-41": "地址",
    "smartElectricity.smarElectricity.218347-42": "手机",
    "smartElectricity.smarElectricity.218347-43": "请输入设备码搜索",
    "smartElectricity.smarElectricity.218347-44": "暂无设备",
    "smartElectricity.smarElectricity.218347-45": "设备详情",
    "smartElectricity.smarElectricity.218347-46": "设备名：",
    "smartElectricity.smarElectricity.218347-47": "设备码：",
    "smartElectricity.smarElectricity.218347-48": "开关状态：",
    "smartElectricity.smarElectricity.218347-49": "合闸",
    "smartElectricity.smarElectricity.218347-50": "分闸",
    "smartElectricity.smarElectricity.218347-51": "在线状态：",
    "smartElectricity.smarElectricity.218347-52": "离线",
    "smartElectricity.smarElectricity.218347-53": "设备地址：",
    "smartElectricity.smarElectricity.218347-54": "联系电话：",
    "smartElectricity.smarElectricity.218347-55": "未设置",
    "smartElectricity.smarElectricity.218347-56": "确定给设备消音？",
    "smartElectricity.smarElectricity.218347-57": "消音",
    "smartElectricity.smarElectricity.218347-58": "召测",
    "smartElectricity.smarElectricity.218347-59": "确定分闸吗？",
    "smartElectricity.smarElectricity.218347-60": "确定合闸吗？",
    "smartElectricity.smarElectricity.218347-61": "确定关阀吗？",
    "smartElectricity.smarElectricity.218347-62": "关阀",
    "smartElectricity.smarElectricity.218347-63": "探头",
    "smartElectricity.smarElectricity.218347-64": "修改",
    "smartElectricity.smarElectricity.218347-65": "是否解除绑定？",
    "smartElectricity.smarElectricity.218347-66": "删除",
    "smartElectricity.smarElectricity.218347-67": "时钟",
    "smartElectricity.smarElectricity.218347-68": "密码",
    "smartElectricity.smarElectricity.218347-69": "实时数据",
    "smartElectricity.smarElectricity.218347-70": "设备监测",
    "smartElectricity.smarElectricity.218347-71": "历史报警",
    "smartElectricity.smarElectricity.218347-72": "参数设置",
    "smartElectricity.smarElectricity.218347-73": "功能开关状态：",
    "smartElectricity.smarElectricity.218347-74": "电池类型：",
    "smartElectricity.smarElectricity.218347-75": "电量状态：",
    "smartElectricity.smarElectricity.218347-76": "电池剩余电量：",
    "smartElectricity.smarElectricity.218347-77": "监测状态：",
    "smartElectricity.smarElectricity.218347-78": "防拆：",
    "smartElectricity.smarElectricity.218347-79": "湿度值：",
    "smartElectricity.smarElectricity.218347-80": "温度值：",
    "smartElectricity.smarElectricity.218347-81": "供电方式：",
    "smartElectricity.smarElectricity.218347-82": "电池供电：",
    "smartElectricity.smarElectricity.218347-83": "电池电量：",
    "smartElectricity.smarElectricity.218347-84": "电池电压：",
    "smartElectricity.smarElectricity.218347-85": "电池电量百分百：",
    "smartElectricity.smarElectricity.218347-86": "通讯时间：",
    "smartElectricity.smarElectricity.218347-87": "请选择某一天数据",
    "smartElectricity.smarElectricity.218347-88": "电压",
    "smartElectricity.smarElectricity.218347-89": "电流",
    "smartElectricity.smarElectricity.218347-90": "温度",
    "smartElectricity.smarElectricity.218347-91": "有功功率",
    "smartElectricity.smarElectricity.218347-92": "无功功率",
    "smartElectricity.smarElectricity.218347-93": "漏电",
    "smartElectricity.smarElectricity.218347-94": "请处理",
    "smartElectricity.smarElectricity.218347-95": "处理",
    "smartElectricity.smarElectricity.218347-96": "误报",
    "smartElectricity.smarElectricity.218347-97": "暂无报警信息",
    "smartElectricity.smarElectricity.218347-98": "过流保护",
    "smartElectricity.smarElectricity.218347-99": "过流跳闸定值",
    "smartElectricity.smarElectricity.218347-100": "过流告警定值",
    "smartElectricity.smarElectricity.218347-101": "过流跳闸延迟",
    "smartElectricity.smarElectricity.218347-102": "过流告警延迟",
    "smartElectricity.smarElectricity.218347-103": "过流告警投退",
    "smartElectricity.smarElectricity.218347-104": "退出",
    "smartElectricity.smarElectricity.218347-105": "投入",
    "smartElectricity.smarElectricity.218347-106": "过流跳闸投退",
    "smartElectricity.smarElectricity.218347-107": "过流跳闸闭锁",
    "smartElectricity.smarElectricity.218347-108": "过载保护",
    "smartElectricity.smarElectricity.218347-109": "过载跳闸定值",
    "smartElectricity.smarElectricity.218347-110": "过载告警定值",
    "smartElectricity.smarElectricity.218347-111": "过载跳闸延迟",
    "smartElectricity.smarElectricity.218347-112": "过载告警延迟",
    "smartElectricity.smarElectricity.218347-113": "过载告警投退",
    "smartElectricity.smarElectricity.218347-114": "过载跳闸投退",
    "smartElectricity.smarElectricity.218347-115": "过载跳闸闭锁",
    "smartElectricity.smarElectricity.218347-116": "漏电保护",
    "smartElectricity.smarElectricity.218347-117": "漏电跳闸定值",
    "smartElectricity.smarElectricity.218347-118": "漏电告警定值",
    "smartElectricity.smarElectricity.218347-119": "漏电跳闸延迟",
    "smartElectricity.smarElectricity.218347-120": "漏电告警延迟",
    "smartElectricity.smarElectricity.218347-121": "漏电告警投退",
    "smartElectricity.smarElectricity.218347-122": "漏电跳闸投退",
    "smartElectricity.smarElectricity.218347-123": "过压保护",
    "smartElectricity.smarElectricity.218347-124": "过压跳闸定值",
    "smartElectricity.smarElectricity.218347-125": "过压告警定值",
    "smartElectricity.smarElectricity.218347-126": "过压跳闸延迟",
    "smartElectricity.smarElectricity.218347-127": "过压告警延迟",
    "smartElectricity.smarElectricity.218347-128": "过压告警投退",
    "smartElectricity.smarElectricity.218347-129": "过压跳闸投退",
    "smartElectricity.smarElectricity.218347-130": "欠压保护",
    "smartElectricity.smarElectricity.218347-131": "欠压跳闸定值",
    "smartElectricity.smarElectricity.218347-132": "欠压告警定值",
    "smartElectricity.smarElectricity.218347-133": "欠压跳闸延迟",
    "smartElectricity.smarElectricity.218347-134": "欠压告警延迟",
    "smartElectricity.smarElectricity.218347-135": "欠压告警投退",
    "smartElectricity.smarElectricity.218347-136": "欠压跳闸投退",
    "smartElectricity.smarElectricity.218347-137": "过欠压恢复",
    "smartElectricity.smarElectricity.218347-138": "过压恢复合闸定值",
    "smartElectricity.smarElectricity.218347-139": "欠压恢复合闸定值",
    "smartElectricity.smarElectricity.218347-140": "过压恢复合闸延时",
    "smartElectricity.smarElectricity.218347-141": "欠压恢复合闸延时",
    "smartElectricity.smarElectricity.218347-142": "过压恢复合闸投退",
    "smartElectricity.smarElectricity.218347-143": "欠压恢复合闸投退",
    "smartElectricity.smarElectricity.218347-144": "电弧保护",
    "smartElectricity.smarElectricity.218347-145": "电弧跳闸定值",
    "smartElectricity.smarElectricity.218347-146": "电弧告警定值",
    "smartElectricity.smarElectricity.218347-147": "电弧跳闸延迟",
    "smartElectricity.smarElectricity.218347-148": "电弧告警延迟",
    "smartElectricity.smarElectricity.218347-149": "电弧告警投退",
    "smartElectricity.smarElectricity.218347-150": "电弧跳闸投退",
    "smartElectricity.smarElectricity.218347-151": "过温保护",
    "smartElectricity.smarElectricity.218347-152": "过温跳闸定值",
    "smartElectricity.smarElectricity.218347-153": "过温告警定值",
    "smartElectricity.smarElectricity.218347-154": "过温跳闸延迟",
    "smartElectricity.smarElectricity.218347-155": "过温告警延迟",
    "smartElectricity.smarElectricity.218347-156": "过温告警投退",
    "smartElectricity.smarElectricity.218347-157": "过温跳闸投退",
    "smartElectricity.smarElectricity.218347-158": "缺相保护",
    "smartElectricity.smarElectricity.218347-159": "缺相跳闸定值",
    "smartElectricity.smarElectricity.218347-160": "缺相告警定值",
    "smartElectricity.smarElectricity.218347-161": "缺相跳闸延迟",
    "smartElectricity.smarElectricity.218347-162": "缺相告警延迟",
    "smartElectricity.smarElectricity.218347-163": "缺相告警投退",
    "smartElectricity.smarElectricity.218347-164": "缺相跳闸投退",
    "smartElectricity.smarElectricity.218347-165": "连续动作闭锁",
    "smartElectricity.smarElectricity.218347-166": "闭锁时间",
    "smartElectricity.smarElectricity.218347-167": "动作次数",
    "smartElectricity.smarElectricity.218347-168": "三相过压恢复",
    "smartElectricity.smarElectricity.218347-169": "三相欠压恢复",
    "smartElectricity.smarElectricity.218347-170": "过欠压恢复时间",
    "smartElectricity.smarElectricity.218347-171": "系统参数",
    "smartElectricity.smarElectricity.218347-172": "电量储存间隔",
    "smartElectricity.smarElectricity.218347-173": "立即储存电量阈值",
    "smartElectricity.smarElectricity.218347-174": "间隔电量储存阈值",
    "smartElectricity.smarElectricity.218347-175": "电量",
    "smartElectricity.smarElectricity.218347-176": "升级重启最大次数",
    "smartElectricity.smarElectricity.218347-177": "心跳异常重启次数",
    "smartElectricity.smarElectricity.218347-178": "提交设置",
    "smartElectricity.smarElectricity.218347-179": "召测阈值",
    "smartElectricity.smarElectricity.218347-180": "召测阈值1",
    "smartElectricity.smarElectricity.218347-181": "召测阈值2",
    "smartElectricity.smarElectricity.218347-182": "即时告警消息",
    "smartElectricity.smarElectricity.218347-183": "设备名称",
    "smartElectricity.smarElectricity.218347-184": "设备编号",
    "smartElectricity.smarElectricity.218347-185": "用户名称",
    "smartElectricity.smarElectricity.218347-186": "详细地址",
    "smartElectricity.smarElectricity.218347-187": "时间",
    "smartElectricity.smarElectricity.218347-188": "类型",
    "smartElectricity.smarElectricity.218347-189": "操作",
    "smartElectricity.smarElectricity.218347-190": "暂无告警消息",
    "smartElectricity.smarElectricity.218347-191": "更多",
    "smartElectricity.smarElectricity.218347-192": "添加区域",
    "smartElectricity.smarElectricity.218347-193": "区域名称",
    "smartElectricity.smarElectricity.218347-194": "请输入区域名称",
    "smartElectricity.smarElectricity.218347-195": "搜索地址",
    "smartElectricity.smarElectricity.218347-196": "经度",
    "smartElectricity.smarElectricity.218347-197": "纬度",
    "smartElectricity.smarElectricity.218347-198": "备注",
    "smartElectricity.smarElectricity.218347-199": "请输入备注",
    "smartElectricity.smarElectricity.218347-200": "下一步",
    "smartElectricity.smarElectricity.218347-201": "取消",
    "smartElectricity.smarElectricity.218347-202": "用户列表",
    "smartElectricity.smarElectricity.218347-203": "添加用户",
    "smartElectricity.smarElectricity.218347-204": "登录用户名",
    "smartElectricity.smarElectricity.218347-205": "移动电话",
    "smartElectricity.smarElectricity.218347-206": "电子邮件",
    "smartElectricity.smarElectricity.218347-207": "联系地址",
    "smartElectricity.smarElectricity.218347-208": "是否管理员",
    "smartElectricity.smarElectricity.218347-209": "是",
    "smartElectricity.smarElectricity.218347-210": "否",
    "smartElectricity.smarElectricity.218347-211": "暂无用户",
    "smartElectricity.smarElectricity.218347-212": "部门列表",
    "smartElectricity.smarElectricity.218347-213": "添加部门",
    "smartElectricity.smarElectricity.218347-214": "部门编号",
    "smartElectricity.smarElectricity.218347-215": "部门名称",
    "smartElectricity.smarElectricity.218347-216": "创建人员",
    "smartElectricity.smarElectricity.218347-217": "创建日期",
    "smartElectricity.smarElectricity.218347-218": "权限",
    "smartElectricity.smarElectricity.218347-219": "城市",
    "smartElectricity.smarElectricity.218347-220": "暂无部门",
    "smartElectricity.smarElectricity.218347-221": "公司列表",
    "smartElectricity.smarElectricity.218347-222": "添加公司",
    "smartElectricity.smarElectricity.218347-223": "公司编号",
    "smartElectricity.smarElectricity.218347-224": "公司名称",
    "smartElectricity.smarElectricity.218347-225": "联系电话",
    "smartElectricity.smarElectricity.218347-226": "暂无公司",
    "smartElectricity.smarElectricity.218347-227": "添加商户费用",
    "smartElectricity.smarElectricity.218347-228": "购买类型",
    "smartElectricity.smarElectricity.218347-229": "价格",
    "smartElectricity.smarElectricity.218347-230": "月",
    "smartElectricity.smarElectricity.218347-231": "季",
    "smartElectricity.smarElectricity.218347-232": "年",
    "smartElectricity.smarElectricity.218347-233": "元",
    "smartElectricity.smarElectricity.218347-234": "添加商户费用模板",
    "smartElectricity.smarElectricity.218347-235": "购买类别",
    "smartElectricity.smarElectricity.218347-236": "请输入价格",
    "smartElectricity.smarElectricity.218347-237": "提交",
    "smartElectricity.smarElectricity.218347-238": "重置",
    "smartElectricity.smarElectricity.218347-239": "修改商户费用模板",
    "smartElectricity.smarElectricity.218347-240": "集团列表",
    "smartElectricity.smarElectricity.218347-241": "添加集团",
    "smartElectricity.smarElectricity.218347-242": "集团编号",
    "smartElectricity.smarElectricity.218347-243": "集团名称",
    "smartElectricity.smarElectricity.218347-244": "暂无集团",
    "smartElectricity.smarElectricity.218347-245": "选择集团",
    "smartElectricity.smarElectricity.218347-246": "选择公司",
    "smartElectricity.smarElectricity.218347-247": "选择部门",
    "smartElectricity.smarElectricity.218347-248": "员工编号",
    "smartElectricity.smarElectricity.218347-249": "请输入员工编号",
    "smartElectricity.smarElectricity.218347-250": "请输入登录用户名",
    "smartElectricity.smarElectricity.218347-251": "用户登录密码",
    "smartElectricity.smarElectricity.218347-252": "请输入用户登录密码",
    "smartElectricity.smarElectricity.218347-253": "财务权限",
    "smartElectricity.smarElectricity.218347-254": "身份证号码",
    "smartElectricity.smarElectricity.218347-255": "请输入身份证号码",
    "smartElectricity.smarElectricity.218347-256": "姓名",
    "smartElectricity.smarElectricity.218347-257": "请输入姓名",
    "smartElectricity.smarElectricity.218347-258": "请输入移动电话",
    "smartElectricity.smarElectricity.218347-259": "性别",
    "smartElectricity.smarElectricity.218347-260": "男",
    "smartElectricity.smarElectricity.218347-261": "女",
    "smartElectricity.smarElectricity.218347-262": "其他",
    "smartElectricity.smarElectricity.218347-263": "请输入电子邮件",
    "smartElectricity.smarElectricity.218347-264": "请输入联系地址",
    "smartElectricity.smarElectricity.218347-265": "出生年月",
    "smartElectricity.smarElectricity.218347-266": "请输入出生年月",
    "smartElectricity.smarElectricity.218347-267": "受教育程度",
    "smartElectricity.smarElectricity.218347-268": "请输入受教育程度",
    "smartElectricity.smarElectricity.218347-269": "请输入部门编号",
    "smartElectricity.smarElectricity.218347-270": "请输入部门名称",
    "smartElectricity.smarElectricity.218347-271": "公司标题",
    "smartElectricity.smarElectricity.218347-272": "请输入公司标题",
    "smartElectricity.smarElectricity.218347-273": "请输入公司编号",
    "smartElectricity.smarElectricity.218347-274": "请输入公司名称",
    "smartElectricity.smarElectricity.218347-275": "请输入联系电话",
    "smartElectricity.smarElectricity.218347-276": "开户银行",
    "smartElectricity.smarElectricity.218347-277": "请输入开户银行",
    "smartElectricity.smarElectricity.218347-278": "开户卡号",
    "smartElectricity.smarElectricity.218347-279": "请输入开户卡号",
    "smartElectricity.smarElectricity.218347-280": "营业执照",
    "smartElectricity.smarElectricity.218347-281": "请输入营业执照",
    "smartElectricity.smarElectricity.218347-282": "请输入地址",
    "smartElectricity.smarElectricity.218347-283": "公司中文名称",
    "smartElectricity.smarElectricity.218347-284": "请输入中文名称",
    "smartElectricity.smarElectricity.218347-285": "公司英文名称",
    "smartElectricity.smarElectricity.218347-286": "请输入英文名称",
    "smartElectricity.smarElectricity.218347-287": "公司logo",
    "smartElectricity.smarElectricity.218347-288": "请输入集团编号",
    "smartElectricity.smarElectricity.218347-289": "请输入集团名称",
    "smartElectricity.smarElectricity.218347-290": "修改用户",
    "smartElectricity.smarElectricity.218347-291": "修改部门",
    "smartElectricity.smarElectricity.218347-292": "修改公司",
    "smartElectricity.smarElectricity.218347-293": "编辑集团",
    "smartElectricity.smarElectricity.218347-294": "选择城市",
    "smartElectricity.smarElectricity.218347-295": "分配权限",
    "smartElectricity.smarElectricity.218347-296": "设备添加权限",
    "smartElectricity.smarElectricity.218347-297": "微断设备操作按钮",
    "smartElectricity.smarElectricity.218347-298": "烟感设备操作按钮",
    "smartElectricity.smarElectricity.218347-299": "气感设备操作按钮",
    "smartElectricity.smarElectricity.218347-300": "权限设置",
    "smartElectricity.smarElectricity.218347-301": "业主电话",
    "smartElectricity.smarElectricity.218347-302": "请输入业主电话",
    "smartElectricity.smarElectricity.218347-303": "查询",
    "smartElectricity.smarElectricity.218347-304": "幢",
    "smartElectricity.smarElectricity.218347-305": "请输入幢",
    "smartElectricity.smarElectricity.218347-306": "单元",
    "smartElectricity.smarElectricity.218347-307": "请输入单元",
    "smartElectricity.smarElectricity.218347-308": "楼层",
    "smartElectricity.smarElectricity.218347-309": "请输入楼层",
    "smartElectricity.smarElectricity.218347-310": "用户号",
    "smartElectricity.smarElectricity.218347-311": "请输入用户号",
    "smartElectricity.smarElectricity.218347-312": "业主姓名",
    "smartElectricity.smarElectricity.218347-313": "请输入业主姓名",
    "smartElectricity.smarElectricity.218347-314": "请输入详细地址",
    "smartElectricity.smarElectricity.218347-315": "设备编码",
    "smartElectricity.smarElectricity.218347-316": "请输入设备编码",
    "smartElectricity.smarElectricity.218347-317": "请输入设备名称",
    "smartElectricity.smarElectricity.218347-318": "安装时间",
    "smartElectricity.smarElectricity.218347-319": "请选择安装时间",
    "smartElectricity.smarElectricity.218347-320": "设备种类",
    "smartElectricity.smarElectricity.218347-321": "请选择设备种类",
    "smartElectricity.smarElectricity.218347-322": "微断",
    "smartElectricity.smarElectricity.218347-323": "烟感",
    "smartElectricity.smarElectricity.218347-324": "气感",
    "smartElectricity.smarElectricity.218347-325": "连接设备",
    "smartElectricity.smarElectricity.218347-326": "请选择连接设备",
    "smartElectricity.smarElectricity.218347-327": "设备类型",
    "smartElectricity.smarElectricity.218347-328": "请选择设备类型",
    "smartElectricity.smarElectricity.218347-329": "设备通讯地址",
    "smartElectricity.smarElectricity.218347-330": "请选择设备通讯地址",
    "smartElectricity.smarElectricity.218347-331": "微断设备",
    "smartElectricity.smarElectricity.218347-332": "请选择设备",
    "smartElectricity.smarElectricity.218347-333": "修改设备",
    "smartElectricity.smarElectricity.218347-334": "联系人",
    "smartElectricity.smarElectricity.218347-335": "请输入联系人",
    "smartElectricity.smarElectricity.218347-336": "设置操作密码",
    "smartElectricity.smarElectricity.218347-337": "请输入密码",
    "smartElectricity.smarElectricity.218347-338": "确认密码",
    "smartElectricity.smarElectricity.218347-339": "请确认密码",
    "smartElectricity.smarElectricity.218347-340": "修改操作密码",
    "smartElectricity.smarElectricity.218347-341": "原密码",
    "smartElectricity.smarElectricity.218347-342": "新密码",
    "smartElectricity.smarElectricity.218347-343": "查找设备",
    "smartElectricity.smarElectricity.218347-344": "手机号",
    "smartElectricity.smarElectricity.218347-345": "请输入手机号",
    "smartElectricity.smarElectricity.218347-346": "请输入设备编号",
    "smartElectricity.smarElectricity.218347-347": "告警消息",
    "smartElectricity.smarElectricity.218347-348": "报警时间",
    "smartElectricity.smarElectricity.218347-349": "报警类型",
    "smartElectricity.smarElectricity.218347-350": "暂无报警",
    "smartElectricity.smarElectricity.218347-351": "已处理",
    "smartElectricity.smarElectricity.218347-352": "请选择日期",
    "smartElectricity.smarElectricity.218347-353": "状态",
    "smartElectricity.smarElectricity.218347-354": "添加城市",
    "smartElectricity.smarElectricity.218347-355": "省份",
    "smartElectricity.smarElectricity.218347-356": "请选择省份",
    "smartElectricity.smarElectricity.218347-357": "请选择城市",
    "smartElectricity.smarElectricity.218347-358": "在线设备列表",
    "smartElectricity.smarElectricity.218347-359": "设备地址",
    "smartElectricity.smarElectricity.218347-360": "通讯时间",
    "smartElectricity.smarElectricity.218347-361": "设备状态",
    "smartElectricity.smarElectricity.218347-362": "离线设备列表",
    "smartElectricity.smarElectricity.218347-363": "所属区域",
    "smartElectricity.smarElectricity.218347-364": "用户地址",
    "smartElectricity.smarElectricity.218347-365": "注册时间",
    "smartElectricity.smarElectricity.218347-366": "用户名",
    "smartElectricity.smarElectricity.218347-367": "房间号",
    "smartElectricity.smarElectricity.218347-368": "编辑",
    "smartElectricity.smarElectricity.218347-369": "报警设备列表",
    "smartElectricity.smarElectricity.218347-370": "在线状态",
    "smartElectricity.smarElectricity.218347-371": "结算申请列表",
    "smartElectricity.smarElectricity.218347-372": "已撤销",
    "smartElectricity.smarElectricity.218347-373": "已结算",
    "smartElectricity.smarElectricity.218347-374": "待结算",
    "smartElectricity.smarElectricity.218347-375": "结算编号",
    "smartElectricity.smarElectricity.218347-376": "支付方式",
    "smartElectricity.smarElectricity.218347-377": "卡号",
    "smartElectricity.smarElectricity.218347-378": "真实姓名",
    "smartElectricity.smarElectricity.218347-379": "结算金额",
    "smartElectricity.smarElectricity.218347-380": "平台佣金费用百分比",
    "smartElectricity.smarElectricity.218347-381": "平台佣金费用",
    "smartElectricity.smarElectricity.218347-382": "最终结算金额",
    "smartElectricity.smarElectricity.218347-383": "结算",
    "smartElectricity.smarElectricity.218347-384": "查看",
    "smartElectricity.smarElectricity.218347-385": "撤销",
    "smartElectricity.smarElectricity.218347-386": "暂无申请列表",
    "smartElectricity.smarElectricity.218347-387": "设置平台结算费率",
    "smartElectricity.smarElectricity.218347-388": "结算费率",
    "smartElectricity.smarElectricity.218347-389": "请输入费率（%）",
    "smartElectricity.smarElectricity.218347-390": "保存",
    "smartElectricity.smarElectricity.218347-391": "修改城市",
    "smartElectricity.smarElectricity.218347-392": "添加乡镇",
    "smartElectricity.smarElectricity.218347-393": "乡镇/街道名称",
    "smartElectricity.smarElectricity.218347-394": "请输入乡镇/街道名称",
    "smartElectricity.smarElectricity.218347-395": "修改街道",
    "smartElectricity.smarElectricity.218347-396": "乡镇名称",
    "smartElectricity.smarElectricity.218347-397": "请输入街道名称",
    "smartElectricity.smarElectricity.218347-398": "添加村",
    "smartElectricity.smarElectricity.218347-399": "村名称",
    "smartElectricity.smarElectricity.218347-400": "请输入村名称",
    "smartElectricity.smarElectricity.218347-401": "修改村",
    "smartElectricity.smarElectricity.218347-402": "修改区域",
    "smartElectricity.smarElectricity.218347-403": "探头列表",
    "smartElectricity.smarElectricity.218347-404": "探头名称",
    "smartElectricity.smarElectricity.218347-405": "当前浓度值",
    "smartElectricity.smarElectricity.218347-406": "报警状态",
    "smartElectricity.smarElectricity.218347-407": "创建时间",
    "smartElectricity.smarElectricity.218347-408": "暂无探头",
    "smartElectricity.smarElectricity.218347-409": "用户授权列表",
    "smartElectricity.smarElectricity.218347-410": "添加授权",
    "smartElectricity.smarElectricity.218347-411": "逸慧家用户名",
    "smartElectricity.smarElectricity.218347-412": "用户登录手机号",
    "smartElectricity.smarElectricity.218347-413": "授权码",
    "smartElectricity.smarElectricity.218347-414": "授权类型",
    "smartElectricity.smarElectricity.218347-415": "授权模块",
    "smartElectricity.smarElectricity.218347-416": "永久授权",
    "smartElectricity.smarElectricity.218347-417": "有效期授权",
    "smartElectricity.smarElectricity.218347-418": "未授权",
    "smartElectricity.smarElectricity.218347-419": "暂无授权",
    "smartElectricity.smarElectricity.218347-420": "时钟设置",
    "smartElectricity.smarElectricity.218347-421": "设置时间",
    "smartElectricity.smarElectricity.218347-422": "设备时钟",
    "smartElectricity.smarElectricity.218347-423": "设置时钟",
    "smartElectricity.smarElectricity.218347-424": "读取时钟",
    "smartElectricity.smarElectricity.218347-425": "修改授权",
    "smartElectricity.smarElectricity.218347-426": "请输入用户登录手机号",
    "smartElectricity.smarElectricity.218347-427": "请输入授权类型",
    "smartElectricity.smarElectricity.218347-428": "有效期开始时间",
    "smartElectricity.smarElectricity.218347-429": "请选择有效期开始时间",
    "smartElectricity.smarElectricity.218347-430": "有效期结束时间",
    "smartElectricity.smarElectricity.218347-431": "请选择有效期结束时间",
    "smartElectricity.smarElectricity.218347-432": "请选择授权模块",
    "smartElectricity.smarElectricity.218347-433": "选择模块",
    "smartElectricity.smarElectricity.218347-434": "添加",
    "smartElectricity.smarElectricity.218347-435": "查无设备",
    "smartElectricity.smarElectricity.218347-436": "导入",
    "smartElectricity.smarElectricity.218347-437": "处理结算",
    "smartElectricity.smarElectricity.218347-438": "结算单号",
    "smartElectricity.smarElectricity.218347-439": "请输入费率",
    "smartElectricity.smarElectricity.218347-440": "支付类型",
    "smartElectricity.smarElectricity.218347-441": "请支付类型",
    "smartElectricity.smarElectricity.218347-442": "订单列表",
    "smartElectricity.smarElectricity.218347-443": "订单编号",
    "smartElectricity.smarElectricity.218347-444": "实收金额",
    "smartElectricity.smarElectricity.218347-445": "支付时间",
    "smartElectricity.smarElectricity.218347-446": "暂无订单",
    "smartElectricity.smarElectricity.218347-447": "报警信息",
    "smartElectricity.smarElectricity.218347-448": "设备报警",
    "smartElectricity.smarElectricity.218347-449": "设备'{0}'在{1}发生{2}报警，请及时处理",
    "smartElectricity.smarElectricity.218347-450": "查看详情",
    "smartElectricity.smarElectricity.218347-451": "无",
    "smartElectricity.smarElectricity.218347-452": "所属城市",
    "smartElectricity.smarElectricity.218347-453": "省",
    "smartElectricity.smarElectricity.218347-454": "市",
    "smartElectricity.smarElectricity.218347-455": "区",
    "smartElectricity.smarElectricity.218347-456": "维修人姓名",
    "smartElectricity.smarElectricity.218347-457": "维修人电话",
    "smartElectricity.smarElectricity.218347-458": "维修人身份证号码",
    "smartElectricity.smarElectricity.218347-459": "维修时间",
    "smartElectricity.smarElectricity.218347-460": "维修信息",
    "smartElectricity.smarElectricity.218347-461": "维修人身份证图片",
    "smartElectricity.smarElectricity.218347-462": "确定",
    "smartElectricity.smarElectricity.218347-463": "未开启",
    "smartElectricity.smarElectricity.218347-464": "开启",
    "smartElectricity.smarElectricity.218347-465": "门锁设备",
    "smartElectricity.smarElectricity.218347-466": "烟感设备",
    "smartElectricity.smarElectricity.218347-467": "气感设备",
    "smartElectricity.smarElectricity.218347-468": "Zigbee设备",
    "smartElectricity.smarElectricity.218347-469": "监控设备",
    "smartElectricity.smarElectricity.218347-470": "全部模块",
    "smartElectricity.smarElectricity.218347-471": "已选{0}个模块",
    "smartElectricity.smarElectricity.218347-472": "浙江省-杭州市",
    "smartElectricity.smarElectricity.218347-473": "点击此功能菜单进入导入流程",
    "smartElectricity.smarElectricity.218347-474": "输入手机号",
    "smartElectricity.smarElectricity.218347-475": "输入需要导入的手机号，点击下一步即成功导入注册信息，注册信息在左侧菜单",
    "smartElectricity.smarElectricity.218347-476": "请选择需要导入的设备，选择完毕点击导入即可",
    "smartElectricity.smarElectricity.218347-477": "左侧菜单",
    "smartElectricity.smarElectricity.218347-478": "您导入的所有信息都会自动生成，左侧菜单可以查看对应内容",
    "smartElectricity.smarElectricity.218347-479": "对接成功！",
    "smartElectricity.smarElectricity.218347-480": "对接失败！",
    "smartElectricity.smarElectricity.218347-481": "已选择全部模块",
    "smartElectricity.smarElectricity.218347-482": "已选择{0}个模块",
    "smartElectricity.smarElectricity.218347-483": "提示",
    "smartElectricity.smarElectricity.218347-484": "是否删除“$",
    "smartElectricity.smarElectricity.218347-485": "编辑区域展开",
    "smartElectricity.smarElectricity.218347-486": "删除返回结果",
    "smartElectricity.smarElectricity.218347-487": "点击修改村展开",
    "smartElectricity.smarElectricity.218347-488": "请求前的数据参数",
    "smartElectricity.smarElectricity.218347-489": "点击街道",
    "smartElectricity.smarElectricity.218347-490": "点击添加时的参数",
    "smartElectricity.smarElectricity.218347-491": "用户添加返回参数",
    "smartElectricity.smarElectricity.218347-492": "点击修改街道展开",
    "smartElectricity.smarElectricity.218347-493": "修改街道前的参数",
    "smartElectricity.smarElectricity.218347-494": "幢-$",
    "smartElectricity.smarElectricity.218347-495": "单元-$",
    "smartElectricity.smarElectricity.218347-496": "楼-$",
    "smartElectricity.smarElectricity.218347-497": "{0}幢-{1}单元-{2}楼-{3}房间",
    "smartElectricity.smarElectricity.218347-498": "是否删除此用户？",
    "smartElectricity.smarElectricity.218347-499": "展开前的参数",
    "smartElectricity.smarElectricity.218347-500": "设备编号不能为空",
    "smartElectricity.smarElectricity.218347-501": "手机号不能为空",
    "smartElectricity.smarElectricity.218347-502": "手机号信息不完整，请使用一键导入功能",
    "smartElectricity.smarElectricity.218347-503": "未选择设备",
    "smartElectricity.smarElectricity.218347-504": "获取导航栏成功",
    "smartElectricity.smarElectricity.218347-505": "设备获取按钮列表",
    "smartElectricity.smarElectricity.218347-506": "请求超时",
    "smartElectricity.smarElectricity.218347-507": "密码不能为空",
    "smartElectricity.smarElectricity.218347-508": "两次密码不相同",
    "smartElectricity.smarElectricity.218347-509": "设置密码成功",
    "smartElectricity.smarElectricity.218347-510": "原密码不能为空",
    "smartElectricity.smarElectricity.218347-511": "新密码不能为空",
    "smartElectricity.smarElectricity.218347-512": "修改密码成功",
    "smartElectricity.smarElectricity.218347-513": "操作密码",
    "smartElectricity.smarElectricity.218347-514": "请输入操作密码",
    "smartElectricity.smarElectricity.218347-515": "您的操作太频繁，请稍后...",
    "smartElectricity.smarElectricity.218347-516": "操作中",
    "smartElectricity.smarElectricity.218347-517": "召测中...",
    "smartElectricity.smarElectricity.218347-518": "召测中",
    "smartElectricity.smarElectricity.218347-519": "A相",
    "smartElectricity.smarElectricity.218347-520": "B相",
    "smartElectricity.smarElectricity.218347-521": "C相",
    "smartElectricity.smarElectricity.218347-522": "总功率",
    "smartElectricity.smarElectricity.218347-523": "是否对设备进行$",
    "smartElectricity.smarElectricity.218347-524": "获取商户费用接口成功",
    "smartElectricity.smarElectricity.218347-525": "添加商户费用模板成功",
    "smartElectricity.smarElectricity.218347-526": "修改的参数",
    "smartElectricity.smarElectricity.218347-527": "发送请求前的参数",
    "smartElectricity.smarElectricity.218347-528": "修改商户费用模板成功",
    "smartElectricity.smarElectricity.218347-529": "点击删除时的id",
    "smartElectricity.smarElectricity.218347-530": "点击删除时获取Uid",
    "smartElectricity.smarElectricity.218347-531": "是否删除？",
    "smartElectricity.smarElectricity.218347-532": "删除商户费用模板成功",
    "smartElectricity.smarElectricity.218347-533": "部门编号不能为空",
    "smartElectricity.smarElectricity.218347-534": "是否删除此部门？",
    "smartElectricity.smarElectricity.218347-535": "公司编号不能为空",
    "smartElectricity.smarElectricity.218347-536": "是否删除此公司？",
    "smartElectricity.smarElectricity.218347-537": "集团编号不能为空",
    "smartElectricity.smarElectricity.218347-538": "是否删除此集团？",
    "smartElectricity.smarElectricity.218347-539": "是否取消编号为“$",
    "smartElectricity.smarElectricity.218347-540": "”的结算",
    "smartElectricity.smarElectricity.218347-541": "结算费率不能为空",
    "smartElectricity.smarElectricity.218347-542": "请选择卡号",
    "smartElectricity.smarElectricity.218347-543": "全部",
    "smartElectricity.smarElectricity.218347-544": "是否删除此用户授权？",
    "smartElectricity.smarElectricity.218347-545": "微软雅黑",
    "smartElectricity.smarElectricity.218347-546": "错误",
    "smartElectricity.smarElectricity.218347-547": "请选择jpg, jpeg, png格式的图片",
    "smartElectricity.smarElectricity.218347-548": "图片最大不能超过2M",
    "smartElectricity.smarElectricity.218347-549": "升级",
    "smartElectricity.smarElectricity.218347-550": "升级指令已下发"
}



// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/smartElectricity-zh.js